require("./jquery-ui-autocomplete.min.js");

var fundExplorer = {
    CountryIso: $("#hdnSelectedCountry").val().toLowerCase(),
    LanguageIso: $("#hdnLanguage").val().toLowerCase(),
    InvestorType: $("#hdnSelectedAudience").val().toLowerCase(),
    InvType: "",
    AssetClass: [],
    Funds: [],
    ShareClass: [],
    TableType: "",
    SortHeader: "",
    SortDesc: "",
    SearchTerm: "",
    loadBlock: false,
    asOfDate: false,
    defaultParams: {
        /**
         * To be automatically populated based on defaults.
         */
        InvType: "",
        AssetClass: [],
        Funds: [],
        ShareClass: [],
        TableType: "",
        SortHeader: "",
        SortDesc: "",
        SearchTerm: "",
    },
    Tickers: [],
    urlParmNames: {
        InvType: "InvType",
        AssetClass: "AssetClass",
        Funds: "Funds",
        ShareClass: "ShareClass",
        TableType: "tab",
        SortHeader: "Sort",
        SortDesc: "SortDesc",
        SearchTerm: "SearchTerm"
    },
    loadVars: {
        hasLoaded: false,
        allEquity: false,
        allIncome: false,
        allCommodity: false,
        allShare: false,
        MFallCommodities: false,
        MFallEquity: false,
        MFallAllocations: false,
        MFallFixedIncome: false
    },


    /***
     * Defining all the UI Components for future reference.
     * */
    uiComponent: {
        /* The dropdown for the Asset class i.e. ETF || MF */
        _dropdownItem_InvestmentType: "#intestmentType .dropdown-item",
        _dropdownLabel_InvestmentType_span: "#investment-type > .dropdown__label",
        _dropdownLabel_InvestmentType: "#investment-type",

        /* The dropdown for the ETF Asset Classes */
        _dropdownLabel_ETF_AssetClasses: "button#asset-classes > #ac-label",
        _checkboxItem_ETF_AllAssetClassItems: "#dropSectionAssetClass input",
        _checkboxItem_ETF_AllCategoryItems: "#dropSectionAssetClass input.etf-category",
        _checkboxItem_ETF_AllEquitites: "#ac-allequities input",
        _checkboxItem_ETF_AllEquitySubItems: "#ac-equities input",
        _checkboxItem_ETF_AllIncome: "#ac-allincome input",
        _checkboxItem_ETF_AllIncomeSubItems: "#ac-income input",
        _checkboxItem_ETF_AllCommodities: "#ac-allcomodity input",
        _checkboxItem_ETF_AllComoditiesSubItems: "#ac-comodity input",

        /* The dropdown for the MF Share Classes */
        _dropdownLabel_MF_ShareClasses: "#share-class > span",
        _checkboxItem_MF_AllShareClasses: "#all-share-classes input",
        _checkboxItem_MF_AllShareClassItemsAndSubitems: "#dropSectionShareClasses input",
        _checkboxItem_MF_AllShareClassSubItems: ".shareClass-group input",

        /* The dropdown for the MF Funds */
        _dropdownLabel_MF_Funds: "#funds-label > span",
        _checkboxItem_MF_AllFundItems: "#dropSectionFunds input:not(.mf-category)",

        /* The specific dropdowns for the MF Funds */
        _checkboxItem_MF_AllEquitites: "#fd-allequities input",
        _checkboxItem_MF_AllEquitySubItems: "#fd-equities input",
        _checkboxItem_MF_AllAllocations: "#fd-allallocations input",
        _checkboxItem_MF_AllAllocationsSubItems: "#fd-allocations input",
        _checkboxItem_MF_AllIncome: "#fd-allincome input",
        _checkboxItem_MF_AllIncomeSubItems: "#fd-income input",
        _checkboxItem_MF_AllCommodities: "#fd-allcommodities input",
        _checkboxItem_MF_AllCommoditiesubItems: "#fd-commodities input",

        /* The tabletype dropdown */
        _dropdownLabel_TableType: "#table-type .dropdown__button",
        _dropdownItem_TableTypes: "#table-type .dropdown__item",
        /* The timePeriod dropdown */
		_dropdownLabel_TimePeriod: "#time .dropdown__button",
        _dropdownItem_TimePeriod: "#time .dropdown__item",

        /* The clear all filters button/link */
        _link_ClearFilters: ".clear-filters",

        /* The Table Title i.e. Mutual Funds || Exchange Traded Funds */
        _h2_TableTitle: "#table-title"
    },

    translationKeys: {
        MutualFunds: "_FundlistingLatam.MutualFunds",
        ETNs: "_FundlistingLatam.ETNs",
        ETFs: "_FundlistingLatam.ETFs",
        Overview: "_FundlistingLatam.Overview",
        Equities: "_FundlistingLatam.Equities",
        Income: "_FundlistingLatam.Income",
        Alternatives: "_FundlistingLatam.Alternatives",
        Commodities: "_FundlistingLatam.Commodities",
        AllClassesEtf: "_FundlistingLatam.AllClassesEtf",
        AllClassesEtn: "_FundlistingLatam.AllClassesEtn",
        AllClassesMf: "_FundlistingLatam.AllClassesMf",
        Select: "_FundlistingLatam.Select",
        Digital: "_FundlistingLatam.Digital",
        Classes: "_FundlistingLatam.Classes",
        AllFunds: "_FundlistingLatam.AllFunds",
        Funds: "_FundlistingLatam.Funds",
        HighToLow: "_FundlistingLatam.HighToLow",
        LowToHigh: "_FundlistingLatam.LowToHigh",
        AsOfDate: "_FundlistingLatam.AsOfDate",
        ShowingFunds: "_FundlistingLatam.ShowingFunds",
        AssetClass: "_FundlistingLatam.Headers.AssetClass",
        Category: "_FundlistingLatam.Headers.Category",
        All: "_FundlistingLatam.All"
    },

    translations: {},

    /**
     * Primary Init Genesis Function that drives the App.
     * */
    init: function () {
        /* 1. Load the spinner and make sure it is running */
        feutils.spinner.init();
        feutils.spinner.load();

        /* 2. Get the current state/config of the page either from URL params || current values on the HTML. */
        fundExplorer.loadTranslations();
        fundExplorer.loadChartsTranslations();
        fundExplorer.trimTrailingSlash();
        fundExplorer.setDefaultParameters();

        /* 3. Apply event listners, then read the default items already selected and click/trigger event listeners appropriately. */
        fundExplorer.basicEventHandlers();
        fundExplorer.setDefaultUIElements();

        /* 4. Now ask for the list of all funds and then use that to load autocomplete and the fund counter. */
        fundExplorer.retrieveAllFundsData();

        /* 5. when ready, ask for the filtered list of funds and start the table rendering process. */
        !fundExplorer.loadVars.hasLoaded ? fundExplorer.loadData() : false;

        /* 6. when ready, create and regen the URL */
        !fundExplorer.loadVars.hasLoaded ? fundExplorer.createFundUrl() : false;

        /* 7. Mark it as ready so that all even listeners will now trigger a table update as needed. */
        fundExplorer.loadVars.hasLoaded = true;
    },

    trimTrailingSlash: function () {
        if(window.location.href.indexOf('/?') > 0) {
            const locationWithoutTrailingSlash = window.location.href.replace('/?', '?');
            if (window.history.replaceState) {
                window.history.replaceState({}, null, locationWithoutTrailingSlash);
            }
        }
    },

    loadTranslations: function () {
        fundExplorer.translations[fundExplorer.translationKeys.MutualFunds] = "Mutual Funds";
        fundExplorer.translations[fundExplorer.translationKeys.ETNs] = "ETNs";
        fundExplorer.translations[fundExplorer.translationKeys.ETFs] = "Exchange Traded Funds";
        fundExplorer.translations[fundExplorer.translationKeys.Overview] = "Overview";
        fundExplorer.translations[fundExplorer.translationKeys.Equities] = "Equities";
        fundExplorer.translations[fundExplorer.translationKeys.Income] = "Income";
        fundExplorer.translations[fundExplorer.translationKeys.Commodities] = "Commodities";
        fundExplorer.translations[fundExplorer.translationKeys.Alternatives] = "Alternatives";
        fundExplorer.translations[fundExplorer.translationKeys.AllClassesEtf] = "All Classes";
        fundExplorer.translations[fundExplorer.translationKeys.AllClassesEtn] = "All Classes";
        fundExplorer.translations[fundExplorer.translationKeys.AllClassesMf] = "All Classes";
        fundExplorer.translations[fundExplorer.translationKeys.Select] = "Select";
        fundExplorer.translations[fundExplorer.translationKeys.Digital] = "Digital";
        fundExplorer.translations[fundExplorer.translationKeys.Classes] = "Classes";
        fundExplorer.translations[fundExplorer.translationKeys.AllFunds] = "All Funds";
        fundExplorer.translations[fundExplorer.translationKeys.Funds] = "Funds";
        fundExplorer.translations[fundExplorer.translationKeys.HighToLow] = "High to Low";
        fundExplorer.translations[fundExplorer.translationKeys.LowToHigh] = "Low to High";
        fundExplorer.translations[fundExplorer.translationKeys.AsOfDate] = "| as of <strong>{asofdate}</strong>";
        fundExplorer.translations[fundExplorer.translationKeys.ShowingFunds] = "Showing <strong>{currentFunds}</strong> of {totalFunds} total funds ";
        fundExplorer.translations[fundExplorer.translationKeys.AssetClass] = "Asset Class";
        fundExplorer.translations[fundExplorer.translationKeys.Category] = "Category";
        fundExplorer.translations[fundExplorer.translationKeys.All] = "All";

        const translationKeysArray = Object.values(fundExplorer.translationKeys);
        window.globalTranslationService
            .translateKeys(translationKeysArray)
            .then(translations => {
                fundExplorer.translations = translations;
                fundExplorer.refreshAllLabels();
                fundExplorer.setTableTitle();
                fundExplorer.fundCountRefresh();
            });
    },

    loadChartsTranslations: function () {
        window.feCharts.translations[window.feCharts.translationKeys.Performance] = "Performance";
        window.feCharts.translations[window.feCharts.translationKeys.PremiumOrDiscount] = "Premium or Discount";
        window.feCharts.translations[window.feCharts.translationKeys.NavChart] = "Nav Chart";
        window.feCharts.translations[window.feCharts.translationKeys.CumulativeChart] = "Cumulative Chart";
        window.feCharts.translations[window.feCharts.translationKeys.HypotheticalGrowthChart] = "Hypothetical Growth Chart";
        window.feCharts.translations[window.feCharts.translationKeys.PriceChart] = "Price Chart";
        window.feCharts.translations[window.feCharts.translationKeys.DownloadNAVHistory] = "Download NAV History";
        window.feCharts.translations[window.feCharts.translationKeys.CHANGEDATERANGE] = "CHANGE DATE RANGE";
        window.feCharts.translations[window.feCharts.translationKeys.Loading] = "Loading...";
        window.feCharts.translations[window.feCharts.translationKeys.SinceInception] = "Since Inception ";
        window.feCharts.translations[window.feCharts.translationKeys.NoDataForSelectedDateRange] = "There is no data for the selected date range.";
        window.feCharts.translations[window.feCharts.translationKeys.yAxisAccessibilityDescription_1] = "trends in premiums and discounts for ";
        window.feCharts.translations[window.feCharts.translationKeys.yAxisAccessibilityDescription_2] = ". A negative number indicates that the funds shares sold at a discount to NAV; a positive number indicates the shares sold at a premium";
        window.feCharts.translations[window.feCharts.translationKeys.SelectDateRange] = "Select Date Range";
        window.feCharts.translations[window.feCharts.translationKeys.Go] = "Go";

        window.feCharts.translations[window.feCharts.translationKeys.January] = "January";
        window.feCharts.translations[window.feCharts.translationKeys.February] = "February";
        window.feCharts.translations[window.feCharts.translationKeys.March] = "March";
        window.feCharts.translations[window.feCharts.translationKeys.April] = "April";
        window.feCharts.translations[window.feCharts.translationKeys.May] = "May";
        window.feCharts.translations[window.feCharts.translationKeys.June] = "June";
        window.feCharts.translations[window.feCharts.translationKeys.July] = "July";
        window.feCharts.translations[window.feCharts.translationKeys.August] = "August";
        window.feCharts.translations[window.feCharts.translationKeys.September] = "September";
        window.feCharts.translations[window.feCharts.translationKeys.October] = "October";
        window.feCharts.translations[window.feCharts.translationKeys.November] = "November";
        window.feCharts.translations[window.feCharts.translationKeys.December] = "December";

        window.feCharts.translations[window.feCharts.translationKeys.ShortJan] = "Jan";
        window.feCharts.translations[window.feCharts.translationKeys.ShortFeb] = "Feb";
        window.feCharts.translations[window.feCharts.translationKeys.ShortMar] = "Mar";
        window.feCharts.translations[window.feCharts.translationKeys.ShortApr] = "Apr";
        window.feCharts.translations[window.feCharts.translationKeys.ShortMay] = "May";
        window.feCharts.translations[window.feCharts.translationKeys.ShortJun] = "Jun";
        window.feCharts.translations[window.feCharts.translationKeys.ShortJul] = "Jul";
        window.feCharts.translations[window.feCharts.translationKeys.ShortAug] = "Aug";
        window.feCharts.translations[window.feCharts.translationKeys.ShortSep] = "Sep";
        window.feCharts.translations[window.feCharts.translationKeys.ShortOct] = "Oct";
        window.feCharts.translations[window.feCharts.translationKeys.ShortNov] = "Nov";
        window.feCharts.translations[window.feCharts.translationKeys.ShortDec] = "Dec";

        window.feCharts.translations[window.feCharts.translationKeys.Sunday] = "Sunday";
        window.feCharts.translations[window.feCharts.translationKeys.Monday] = "Monday";
        window.feCharts.translations[window.feCharts.translationKeys.Tuesday] = "Tuesday";
        window.feCharts.translations[window.feCharts.translationKeys.Wednesday] = "Wednesday";
        window.feCharts.translations[window.feCharts.translationKeys.Thursday] = "Thursday";
        window.feCharts.translations[window.feCharts.translationKeys.Friday] = "Friday";
        window.feCharts.translations[window.feCharts.translationKeys.Saturday] = "Saturday";

        const translationKeysArray = Object.values(window.feCharts.translationKeys);
        window.globalTranslationService
            .translateKeys(translationKeysArray)
            .then(translations => {
                window.feCharts.translations = translations;
                window.feCharts.setHighchartsTranslations();
                $('.daterangepicker .ranges').after('<h5 class="daterangepicker-title">' + window.feCharts.translations[window.feCharts.translationKeys.SelectDateRange] + '</h5>');
                if(fundExplorer.currentdata) {
                    fundExplorer.rnTable(fundExplorer.currentdata);
                    feCharts.activateTabListeners();
                }
            });
    },

    /**
     * Stores the default state of the page when loaded on fundExplorer.defaultParams.
     * Also retrieves the configuration of parameters from the URL if available.
     * If not stores the current values on the fundExplorer object.
     * */
    setDefaultParameters: function () {
        var queryArr = [
			{ name: "InvType", type: "string", element: $(fundExplorer.uiComponent._dropdownItem_InvestmentType).parents(".dropdown").find(".dropdown__button") },
			{ name: "AssetClass", type: "array", element: $(fundExplorer.uiComponent._checkboxItem_ETF_AllAssetClassItems) },
			{ name: "Funds", type: "array", element: $(fundExplorer.uiComponent._checkboxItem_MF_AllFundItems) },
			{ name: "ShareClass", type: "array", element: $(fundExplorer.uiComponent._checkboxItem_MF_AllShareClassItemsAndSubitems) },
			{ name: "TableType", type: "string", element: $(fundExplorer.uiComponent._dropdownItem_TableTypes).parents(".dropdown").find(".dropdown__button") },
			{ name: "SortHeader", type: "string" },
			{ name: "SortDesc", type: "string" },
            { name: "SearchTerm", type: "string" }
		];

        $.each(queryArr, function (index, value) {

            /**
             * 1. Store Default Params seperately, for later use
             * All parameters loaded by default will be identified and stored.
             * These are stored in fundExplorer.defaultParams. (i.e. a "shadow configuration")
             * */
            if (queryArr[index].element && queryArr[index].type == "array") {
                $(queryArr[index].element).each(function () {
                    /* All values must be stores here regardless of whether it is checked on not, this is for search! */
                    $(this).val() != "" ? fundExplorer.defaultParams[queryArr[index].name].push($(this).val()) : false;
                });
            }
            else if (queryArr[index].element && queryArr[index].type != "array") {
                fundExplorer.defaultParams[queryArr[index].name] = queryArr[index].element.val();
            };

            /**
             * 2.a. See if there is a query parameter already defined for the particular item and if so save it in the primary configuration.
             * */
            var queryValue = fundExplorer.getQueryParameter(fundExplorer.urlParmNames[value.name], value.type);
            if (queryValue) {
                fundExplorer[queryArr[index].name] = queryValue;
            }

            /**
             * 2.b. If there is is no query parameter already defined for it, then store value of it in the primary configuration.
             * Handle appropriately if it is supposed to be an array or individual value.
             */
            else if (queryArr[index].element && queryArr[index].type == "array") {
                $(queryArr[index].element).each(function () {
                    $(this).is(':checked') && $(this).val() != "" ? fundExplorer[queryArr[index].name].push($(this).val()) : false;
                });
            }
            else if (queryArr[index].element && queryArr[index].type != "array") {
                fundExplorer[queryArr[index].name] = queryArr[index].element.val();
            };

        /* End loop through each configuration item. */
		});
	},


    /*****
     * ##### EVENT LISTNERS & SETTING DEFAULTS ####
     * This section deals will all of the event listeners and setting of the default items.
     *
     * */
    basicEventHandlers: function() {
        /**
         * A - Investment Type
         * For when you switch from MF to ETF and vice versa
         * Investment Type dropdown event handler */
        $(fundExplorer.uiComponent._dropdownItem_InvestmentType).on("click",
            function () {
                var currInvType = $(fundExplorer.uiComponent._dropdownLabel_InvestmentType).val();
                var newInvType = $(this).val();
                if (currInvType != newInvType) {
                    $(fundExplorer.uiComponent._dropdownLabel_InvestmentType).val(newInvType);
                    $(fundExplorer.uiComponent._dropdownLabel_InvestmentType_span).text($(this).text());
                    fundExplorer.setInvestmentType(newInvType);
                }
            });

        /* *
         * B - ETF Asset Classes
         * Assets classes dorpdown Event handlers */

        /**Our main list of asset classes */
        var assetClassSubItems = [
            {
                /* Equity */
                allItemsCheckbox: fundExplorer.uiComponent._checkboxItem_ETF_AllEquitites,
                subItemsCheckbox: fundExplorer.uiComponent._checkboxItem_ETF_AllEquitySubItems,
                loadedFlag: "allEquity"
            },
            {
                /* Income */
                allItemsCheckbox: fundExplorer.uiComponent._checkboxItem_ETF_AllIncome,
                subItemsCheckbox: fundExplorer.uiComponent._checkboxItem_ETF_AllIncomeSubItems,
                loadedFlag: "allIncome"
            },
            {
                /* Commodities */
                allItemsCheckbox: fundExplorer.uiComponent._checkboxItem_ETF_AllCommodities,
                subItemsCheckbox: fundExplorer.uiComponent._checkboxItem_ETF_AllComoditiesSubItems,
                loadedFlag: "allCommodity"
            }
        ];

        assetClassSubItems.forEach(function (assetClass, i) {
            /**
             Each of the above has two event listeners that need to be attached.
             */

            //1. Event Listener for the main "All" checkbox.
            $(assetClass.allItemsCheckbox).on("change", function () {
                fundExplorer.loadVars[assetClass.loadedFlag] = true;
                if ($(this).is(':checked')) {
                    $(assetClass.subItemsCheckbox).each(function () {
                        !$(this).is(':checked') ? $(this).click() : false;
                    });
                }
                else {
                    $(assetClass.subItemsCheckbox).each(function () {
                        $(this).is(':checked') ? $(this).click() : false;
                    });
                }
                fundExplorer.loadVars.hasLoaded ? fundExplorer.createFundUrl() : false;
                fundExplorer.loadVars.hasLoaded ? fundExplorer.loadData() : false;
                fundExplorer.loadVars[assetClass.loadedFlag] = false;
            });

            //2. Event listener for the subitems.
            $(assetClass.subItemsCheckbox).on("change", function () {
                if ($(this).is(':checked')) {
                    feutils.isAllChecked(assetClass.subItemsCheckbox) ? $(assetClass.allItemsCheckbox).prop('checked', true) : false;
                    fundExplorer.loadVars.hasLoaded ? fundExplorer.AssetClass = fundExplorer.reconstructArray(fundExplorer.AssetClass, $(this).val(), "add") : false;
                }
                else {
                    $(assetClass.allItemsCheckbox).prop('checked', false);
                    fundExplorer.loadVars.hasLoaded ? fundExplorer.AssetClass = fundExplorer.reconstructArray(fundExplorer.AssetClass, $(this).val(), "remove") : false;
                }
                fundExplorer.loadVars.hasLoaded && !fundExplorer.loadVars[assetClass.loadedFlag] ? fundExplorer.createFundUrl() : false;
                fundExplorer.loadVars.hasLoaded && !fundExplorer.loadVars[assetClass.loadedFlag] ? fundExplorer.loadData() : false;
                fundExplorer.refreshAllLabels();
            });


        });


    /**
     * C - MF Fund Dropdown Listner
     * Funds dropdown Event handlers

        /**Our main list of MF Funds */
        var fundsSubItems = [
            {
                /* Equity */
                allItemsCheckbox: fundExplorer.uiComponent._checkboxItem_MF_AllEquitites,
                subItemsCheckbox: fundExplorer.uiComponent._checkboxItem_MF_AllEquitySubItems,
                loadedFlag: "MFallEquity"
            },
            {
                /* Asset Allocation */
                allItemsCheckbox: fundExplorer.uiComponent._checkboxItem_MF_AllAllocations,
                subItemsCheckbox: fundExplorer.uiComponent._checkboxItem_MF_AllAllocationsSubItems,
                loadedFlag: "MFallAllocations"
            },
            {
                /* Fixed Income */
                allItemsCheckbox: fundExplorer.uiComponent._checkboxItem_MF_AllIncome,
                subItemsCheckbox: fundExplorer.uiComponent._checkboxItem_MF_AllIncomeSubItems,
                loadedFlag: "MFallFixedIncome"
            },
            {
                /* Commodities */
                allItemsCheckbox: fundExplorer.uiComponent._checkboxItem_MF_AllCommodities,
                subItemsCheckbox: fundExplorer.uiComponent._checkboxItem_MF_AllCommoditiesubItems,
                loadedFlag: "MFallCommodities"
            }
        ];

        fundsSubItems.forEach(function (assetClass, i) {
            /**
             Each of the above has two event listeners that need to be attached.
             */

            //1. Event Listener for the main "All" checkbox.
            $(assetClass.allItemsCheckbox).on("change", function () {
                fundExplorer.loadVars[assetClass.loadedFlag] = true;
                if ($(this).is(':checked')) {
                    $(assetClass.subItemsCheckbox).each(function () {
                        !$(this).is(':checked') ? $(this).click() : false;
                    });
                }
                else {
                    $(assetClass.subItemsCheckbox).each(function () {
                        $(this).is(':checked') ? $(this).click() : false;
                    });
                }
                fundExplorer.loadVars.hasLoaded ? fundExplorer.createFundUrl() : false;
                fundExplorer.loadVars.hasLoaded ? fundExplorer.loadData() : false;
                fundExplorer.loadVars.hasLoaded ? fundExplorer.refreshAllLabels() : false;
                fundExplorer.loadVars[assetClass.loadedFlag] = false;
            });

            //2. Event listener for the subitems.
            $(assetClass.subItemsCheckbox).on("change", function () {
                if ($(this).is(':checked')) {
                    feutils.isAllChecked(assetClass.subItemsCheckbox) ? $(assetClass.allItemsCheckbox).prop('checked', true) : false;
                    //fundExplorer.loadVars.hasLoaded ? fundExplorer.AssetClass = fundExplorer.reconstructArray(fundExplorer.AssetClass, $(this).val(), "add") : false;
                }
                else {
                    $(assetClass.allItemsCheckbox).prop('checked', false);
                    //fundExplorer.loadVars.hasLoaded ? fundExplorer.AssetClass = fundExplorer.reconstructArray(fundExplorer.AssetClass, $(this).val(), "remove") : false;
                }

                fundExplorer.loadVars.hasLoaded ? fundExplorer.Funds = [] : false;
			    $(fundExplorer.uiComponent._checkboxItem_MF_AllFundItems).each(function () {
                    fundExplorer.loadVars.hasLoaded ? $(this).is(':checked') ? fundExplorer.Funds.push($(this).val()) : false : false;
			    });
			    fundExplorer.loadVars.hasLoaded && !fundExplorer.loadVars[assetClass.loadedFlag] ? fundExplorer.createFundUrl() : false;
                fundExplorer.loadVars.hasLoaded && !fundExplorer.loadVars[assetClass.loadedFlag] ? fundExplorer.loadData() : false;
                fundExplorer.refreshAllLabels();
            });


        });


		/***
         * D - MF Share Class Event Handlers
         * ShareClasses dorpdown Event handlers */

        //1. Common function to run for both main "ALL" checkbox and sub items.
        function refreshShareClasses() {
            fundExplorer.loadVars.hasLoaded ? fundExplorer.ShareClass = [] : false;
            $(fundExplorer.uiComponent._checkboxItem_MF_AllShareClassItemsAndSubitems).each(function () {
                fundExplorer.loadVars.hasLoaded ? $(this).is(':checked') && $(this).val() != "" ? fundExplorer.ShareClass.push($(this).val()) : false : false;
            });
            fundExplorer.refreshAllLabels();
        }



        //2. Listner for the main "All" items checkbox.
		$(fundExplorer.uiComponent._checkboxItem_MF_AllShareClassSubItems).on("change", function () {
			if ($(this).is(':checked')) {
                feutils.isAllChecked(fundExplorer.uiComponent._checkboxItem_MF_AllShareClassSubItems) ? $(fundExplorer.uiComponent._checkboxItem_MF_AllShareClasses).prop('checked', true) : false;
			}
			else {
				$(fundExplorer.uiComponent._checkboxItem_MF_AllShareClasses).prop('checked', false);
            }
            refreshShareClasses()
			fundExplorer.loadVars.hasLoaded && !fundExplorer.loadVars.allShare ? fundExplorer.createFundUrl() : false;
			fundExplorer.loadVars.hasLoaded && !fundExplorer.loadVars.allShare ? fundExplorer.loadData() : false;
        });

        //3. Listener for the subitems (each share class) checkboxes.
		$(fundExplorer.uiComponent._checkboxItem_MF_AllShareClasses).on("change", function () {
			fundExplorer.loadVars.allShare = true;
			if ($(this).is(':checked')) {
				$(fundExplorer.uiComponent._checkboxItem_MF_AllShareClassSubItems).each(function () {
					!$(this).is(':checked') ? $(this).click() : false;
				});
			}
			else {
				$(fundExplorer.uiComponent._checkboxItem_MF_AllShareClassSubItems).each(function () {
					$(this).is(':checked') ? $(this).click() : false;
				});
            }
            refreshShareClasses()
			fundExplorer.loadVars.hasLoaded ? fundExplorer.createFundUrl() : false;
			fundExplorer.loadVars.hasLoaded ? fundExplorer.loadData() : false;
			fundExplorer.loadVars.allShare = false;
		});


		/***
         * E- Table Type Listeners and Time dropdown listener
         * 1. Table Type dorpdown (ie.e Overview, Literature etc.) Event handlers */
        $(fundExplorer.uiComponent._dropdownItem_TableTypes).on("click", function () {
            /* We need to check if either the value or the text is not matching (already selected), if one if them is not already selected, do a click */
            var currTblType = $(this).parents(".dropdown").find(".dropdown__button").val();
            var currTblTypeText = $(this).parents(".dropdown").find(".dropdown__button").text().trim();
            var selectedValue = $(this).val();

			if ((currTblType != selectedValue) || (currTblTypeText != $(this).text().trim())) {
				$(this).parents(".dropdown").find(".dropdown__button").val(selectedValue);
                $(this).parents(".dropdown").find(".dropdown__label").text($(this).text());
                //Special case if it is the returns tab, we need to use the timeperiod dropdown.
				if (selectedValue == "returns") {
					fundExplorer.TableType = $(fundExplorer.uiComponent._dropdownLabel_TimePeriod).val();
					$("body").addClass("active-time");
				}
				else {
					fundExplorer.TableType = selectedValue;
					$("body").removeClass("active-time");
				}
				fundExplorer.loadVars.hasLoaded ? fundExplorer.createFundUrl() : false;
				fundExplorer.loadVars.hasLoaded ? fundExplorer.loadData() : false;
			}
		});

		/* 2. Time dorpdown Event handlers */
		$(fundExplorer.uiComponent._dropdownItem_TimePeriod).on("click", function () {
			var currTime = $(this).parents(".dropdown").find(".dropdown__button").val();
			if (currTime != $(this).val()) {
				$(this).parents(".dropdown").find(".dropdown__button").val($(this).val());
				$(this).parents(".dropdown").find(".dropdown__label").text($(this).text());
				fundExplorer.TableType = $(this).val();
				$(fundExplorer.uiComponent._dropdownLabel_TableType).val("returns");
				$(fundExplorer.uiComponent._dropdownLabel_TableType).find(".dropdown__label").text("returns");
				fundExplorer.loadVars.hasLoaded ? fundExplorer.createFundUrl() : false;
				fundExplorer.loadVars.hasLoaded ? fundExplorer.loadData() : false;
			}
        });

        /* F. Clear all filters Event handler */
        $(fundExplorer.uiComponent._link_ClearFilters).on("click", function () {
            //Disable search if available too...
            $(".fund-explorer-screener__dropdown > .input-group > .input-group-append > .btn").click();
            fundExplorer.clearFilters();
        });

        /**
         * Misc
         * 1. Mega-menu event handler to prevent being overridden by a dropdown.
         */
        $("li.site-header__nav-item.nav-item").hover(function () { $(".dropdown-menu.show").removeClass("show"); $(".dropdown.show, .dropdown-checkbox.show").removeClass("show") });

        //2. Excel Download Event listener.
        $('.fund-explorer-table__download-excel').click(function () {
            fundExplorer.exportExcel();
        });
    },

    setInvestmentType: function(newInvType) {
        newInvType == "mf"
            ? $("body").addClass("active-mf")
            : $("body").removeClass("active-mf");
        newInvType == "etn"
            ? $("body").addClass("active-etn")
            : $("body").removeClass("active-etn");

        const tableTitle = fundExplorer.getTableTitle(newInvType);
        $(fundExplorer.uiComponent._h2_TableTitle).text(tableTitle);
        if(newInvType == "mf" && fundExplorer.TableType == "fe") {
            (fundExplorer.TableType = "ov", $(fundExplorer.uiComponent._dropdownLabel_TableType + " > .dropdown__label").text(fundExplorer.translations[fundExplorer.translationKeys.Overview]))
        }

        fundExplorer.InvType = newInvType;
        if(fundExplorer.loadVars.hasLoaded) {
            fundExplorer.createFundUrl();
            fundExplorer.loadData();
        }
        fundExplorer.autocomplete.activate();
    },

    getTableTitle: function(newInvType) {
        switch (newInvType) {
            case "mf":
                return fundExplorer.translations[fundExplorer.translationKeys.MutualFunds];
            case "etn":
                return fundExplorer.translations[fundExplorer.translationKeys.ETNs];
            case "etf":
                return fundExplorer.translations[fundExplorer.translationKeys.ETFs];
        }
    },
    
    /***
     * This function refresh the labels of the dropdows (e.g. All Share Class, Selected Sahre Class etc.) to change them according to selections.
     */
    refreshAllLabels: function() {
        const accumulatorCheckboxFunction = function(accumulator, currentValue, i) {
            const checkbox = $(currentValue.selector + ":checked");
            if (checkbox.length > 0) {
                accumulator.labelText += currentValue.name + ", ";
                accumulator.counter++;
            }
            return accumulator;
        };
        
        //1. Refresh the Asset Classes for ETFs
        //Get the checkboxes, see if they are checked and change label accordingly.
        var checkboxes = [
            { name: fundExplorer.translations[fundExplorer.translationKeys.Equities], selector: fundExplorer.uiComponent._checkboxItem_ETF_AllEquitySubItems },
            { name: fundExplorer.translations[fundExplorer.translationKeys.Income], selector: fundExplorer.uiComponent._checkboxItem_ETF_AllIncomeSubItems },
            { name: fundExplorer.translations[fundExplorer.translationKeys.Alternatives], selector: fundExplorer.uiComponent._checkboxItem_ETF_AllComoditiesSubItems }
        ]
        const activeEtfGroups = $(fundExplorer.uiComponent._checkboxItem_ETF_AllCategoryItems).length;

        const dropdownEtfLabelOptions = checkboxes.reduce(accumulatorCheckboxFunction, {labelText: "", counter: 0});

        const reducedDropdownEtfLabelText = dropdownEtfLabelOptions.labelText.length > 0
            ? dropdownEtfLabelOptions.labelText.slice(0, -2)
            : fundExplorer.translations[fundExplorer.translationKeys.Select];
        const etfGroupsCurrenltySelected = ` (${dropdownEtfLabelOptions.counter}/${activeEtfGroups})`;

        $(fundExplorer.uiComponent._dropdownLabel_ETF_AssetClasses).text(dropdownEtfLabelOptions.counter === activeEtfGroups
                ? fundExplorer.translations[fundExplorer.translationKeys.AllClassesEtf]
                : reducedDropdownEtfLabelText + etfGroupsCurrenltySelected);

        //2. Refresh the Share Classes for Mutual Funds.
        const getMfClassesDropdownLabelText = function() {
            const allMfClassSubItems = $(fundExplorer.uiComponent._checkboxItem_MF_AllShareClassSubItems).length;
            const checkedMfClassSubItems = $(fundExplorer.uiComponent._checkboxItem_MF_AllShareClassSubItems + ":checked").length;
            const mfClassesCurrenltySelected = ` (${checkedMfClassSubItems}/${allMfClassSubItems})`;

            if(checkedMfClassSubItems === allMfClassSubItems) {
                return fundExplorer.translations[fundExplorer.translationKeys.AllClassesMf];
            }

            if(checkedMfClassSubItems === 0) {
                return fundExplorer.translations[fundExplorer.translationKeys.Select] + mfClassesCurrenltySelected;
            }

            return fundExplorer.translations[fundExplorer.translationKeys.Classes] + mfClassesCurrenltySelected;
        };

        const dropdownMfClassesLabelText = getMfClassesDropdownLabelText();
        $(fundExplorer.uiComponent._dropdownLabel_MF_ShareClasses).text(dropdownMfClassesLabelText);

        //3. The Mutual Funds Funds dropdoown. Count has to ignore all the category labels, hence the "not".
        const getMfFundsDropdownLabelText = function() {
            const allMfFundsSubItems = $('#funds-checkbox-group .custom-checkbox > input:not(.mf-category)').length;
            const checkedMfFundsSubItems = $('#funds-checkbox-group .custom-checkbox > input:not(.mf-category):checked').length;
            const mfFundsCurrenltySelected = ` (${checkedMfFundsSubItems}/${allMfFundsSubItems})`;

            if(checkedMfFundsSubItems === allMfFundsSubItems) {
                return fundExplorer.translations[fundExplorer.translationKeys.AllFunds];
            }

            if(checkedMfFundsSubItems === 0) {
                return fundExplorer.translations[fundExplorer.translationKeys.Select] + mfFundsCurrenltySelected;
            }

            return fundExplorer.translations[fundExplorer.translationKeys.Funds] + mfFundsCurrenltySelected;
        };

        const dropdownMfFundsLabelText = getMfFundsDropdownLabelText();
        $(fundExplorer.uiComponent._dropdownLabel_MF_Funds).text(dropdownMfFundsLabelText);
    },

    setDefaultUIElements: function () {
        //1. Look at the default Investment Type.
        if (fundExplorer.InvType != "") {
            fundExplorer.setTableTitle();
            $(fundExplorer.uiComponent._dropdownItem_InvestmentType).each(function () {
                const investmentType = $(this).val();
                if(investmentType == fundExplorer.InvType) {
                    fundExplorer.setInvestmentType(investmentType);
                }
            });
        }

        //2. Look at the Asset Classes, Funds and ShareClasses, tick them appropriately
        var dropdownItems = [
            { dropdownArray: "AssetClass", allSelector: fundExplorer.uiComponent._checkboxItem_ETF_AllAssetClassItems },
            { dropdownArray: "Funds", allSelector: fundExplorer.uiComponent._checkboxItem_MF_AllFundItems },
            { dropdownArray: "ShareClass", allSelector: fundExplorer.uiComponent._checkboxItem_MF_AllShareClassItemsAndSubitems }
        ]

        dropdownItems.forEach(function (dropdown, i) {
            if (fundExplorer[dropdown.dropdownArray].length > 0) {
                $(dropdown.allSelector).prop('checked', false);
                $.each(fundExplorer[dropdown.dropdownArray], function (index, fundvalue) {
                    $(dropdown.allSelector).each(function () {
                        $(this).val() == fundvalue ? $(this).click() : false;
                    });
                });
            }
        });
        fundExplorer.refreshAllLabels();

        //3. Table types, including special case for returns table.
		if (fundExplorer.TableType != "") {
            if (["month-end-returns", "quarter-end-returns", "annual-returns"].indexOf(fundExplorer.TableType) != -1) {
				$("body").addClass("active-time");
				$(fundExplorer.uiComponent._dropdownItem_TimePeriod).each(function () {
					$(this).val() == fundExplorer.TableType ? $(this).click() : false;
				});
				$(fundExplorer.uiComponent._dropdownLabel_TableType).val("returns");
				$(fundExplorer.uiComponent._dropdownLabel_TableType).find(".dropdown__label").text("returns");
			}
			else {
				$("body").removeClass("active-time");
				$(fundExplorer.uiComponent._dropdownItem_TableTypes).each(function () {
					$(this).val() == fundExplorer.TableType ? $(this).click() : false;
				});
            }
		}

	},

    setTableTitle: function() {
        fundExplorer.InvType == "mf"
            ? $("body").addClass("active-mf")
            : $("body").removeClass("active-mf");
        switch (fundExplorer.InvType) {
            case "etf":
                $(fundExplorer.uiComponent._h2_TableTitle).text(fundExplorer.translations[fundExplorer.translationKeys.ETFs]);
                break;
            case "etn":
                $(fundExplorer.uiComponent._h2_TableTitle).text(fundExplorer.translations[fundExplorer.translationKeys.ETNs]);
                break;
            case "mf":
                $(fundExplorer.uiComponent._h2_TableTitle).text(fundExplorer.translations[fundExplorer.translationKeys.MutualFunds]);
                break;
        }
    },

    reconstructArray: function(array, item, oparation) {
        oparation == "remove" ? array = $.grep(array, function(value) { return value != item }) : array.push(item);
        return array;
    },





    /*****
    * ##### QUERY PARAMETERS AND URLS ####
    * This section deals will the query parameter and URL releated stuff.
    *
    * */
	getQueryParameter: function (query, type) {
        var url = window.location.search.substring(1),
			URLVariables = url.split('&'),
			parameterName,
			i;

        for (i = 0; i < URLVariables.length; i++) {
			parameterName = URLVariables[i].split('=');
			if (parameterName[0] === query) {
				if (type == "array") {
                    return typeof parameterName[1] === undefined ? true : decodeURIComponent(parameterName[1]).split(',');
				}
				else {
					return typeof parameterName[1] === undefined ? true : decodeURIComponent(parameterName[1]);
				}
			}
		}
		return false;
	},

    /**
     * get the list of URL parameters and see which ones are residual (ie. not standard fundexplorer ones).
     */
    getResidualQueryParams: function(addPrefixedAmbersand) {
        addPrefixedAmbersand = addPrefixedAmbersand || false;
        var url = window.location.search.substring(1),
            URLVariables = url.split('&'),
            parameterName,
            residualURL = "",
            i;

        /*1. Get a list of all params pertinent to FundExplorer*/
        var listofparams = [];
        Object.keys(fundExplorer.urlParmNames).forEach(function(key,index) {
            listofparams.push(fundExplorer.urlParmNames[key]);
        });

        /*2. Iterate through all query params. */
        for (i = 0; i < URLVariables.length; i++) {
            parameterName = URLVariables[i].split('=');

            /*3. We have to ignore the ones which are FundExplorer related.*/
            if ( listofparams.indexOf(parameterName[0]) == -1 ) {
                residualURL += "&" + URLVariables[i];
            }
        }

        //Remove the first '&' char
        if (residualURL.length < 2) return "";
        if (!addPrefixedAmbersand) return residualURL.substring(1);
        return residualURL;
    },

	createFundUrl: function () {
        const catList = $.map(fundExplorer.urlParmNames, function (index, value) { return [value] });
        let urlParm = "?";

		$.each(catList, function (index, cat) {
            const catValue = fundExplorer[cat];
            const header = fundExplorer.urlParmNames[cat];
            const none = "_none";
			if (Array.isArray(catValue)) {
				if (catValue.length > 0) {
					urlParm += "&" + header + "=";
					$.each(catValue, function (j, value) {
                        if(value === none && catValue.length > 1) {
                            return;
                        }

                        urlParm += value;
                        if(j + 1 != catValue.length) {
                            urlParm += ","
                        }
					});
				} else {
                    urlParm += "&" + header + "=" + none;
                }
			}
			else {
				if (catValue.length != "") {
                    if(index != 0) {
                        urlParm += "&";
                    }
                    urlParm += header + "=" + catValue;
				};
			}
		});

        //Add any residual parameter when reconstructing the URL
        urlParm += fundExplorer.getResidualQueryParams(true);

		window.history.pushState({}, "", urlParm);
    },

    /***
     * MISC: Clearning all filters. */
    clearFilters: function () {
        fundExplorer.loadVars.hasLoaded = false;
        $(fundExplorer.uiComponent._checkboxItem_ETF_AllAssetClassItems).each(function () {
            !$(this).is(':checked') ? $(this).click() : false;
        });
        $(fundExplorer.uiComponent._checkboxItem_MF_AllFundItems).each(function () {
            !$(this).is(':checked') ? $(this).click() : false;
        });
        $(fundExplorer.uiComponent._checkboxItem_MF_AllShareClassItemsAndSubitems).each(function () {
            !$(this).is(':checked') ? $(this).click() : false;
        });
        $(fundExplorer.uiComponent._dropdownItem_TableTypes).each(function () {
            $(this).val() == "ov" ? $(this).click() : false;
        });
        fundExplorer.AssetClass = [];
        fundExplorer.Funds = [];
        fundExplorer.ShareClass = [];
        fundExplorer.InvType = "";
        fundExplorer.TableType = "";
        window.history.pushState({}, "", "?" + fundExplorer.getResidualQueryParams(false));
        fundExplorer.setDefaultParameters();
        fundExplorer.createFundUrl();
        fundExplorer.loadData();
        fundExplorer.loadVars.hasLoaded = true;
    },


    /*
     * Genesis function to refresh the table
     */

    loadData: function (url, txdata, isGet) {
        url = url || "/Main/FundListingUs/GetFundData";
        if (window.location.search) {
            var searchParams = new URLSearchParams(window.location.search);
            var latest = searchParams.get("latest");
            var epiProjects = searchParams.get("epiprojects");
            if (latest){
                url = url + `${url.indexOf("?") !== -1 ? "&" : "?"}latest=${latest}`;
            }

            if (epiProjects) {
                url = url + `${url.indexOf("?") !== -1 ? "&" : "?"}epiprojects=${epiProjects}`;
            }
        }
        isGet = isGet || false;

        if (!txdata) {

            var assetClasses = feutils.arrString(fundExplorer.AssetClass);
            var shareClasses = feutils.arrString(fundExplorer.ShareClass);
            var Funds = feutils.arrString(fundExplorer.Funds);

            var searchTerm = fundExplorer.SearchTerm;

            if (searchTerm != "") {
                assetClasses = feutils.arrString(fundExplorer.defaultParams.AssetClass);
                shareClasses = feutils.arrString(fundExplorer.defaultParams.ShareClass);
                Funds = feutils.arrString(fundExplorer.defaultParams.Funds);
                var ui = { item: { id: searchTerm } }

                /**
                 * If there is already a search term and search is not locked already, then lock it.
                 */
                $('.jqac .input-group-append').length == 0 ? fundExplorer.autocomplete.select(ui, true) : false;

                /* Search team could be either etf or mf need to figure out */
                var tableType = fundExplorer.getFundTypeFromTicker(searchTerm);

                //console.log("Search in progress TICKER:" + searchTerm + " Current Inv Type: "+ fundExplorer.InvType + " search InvType: " + tableType);



                if (fundExplorer.InvType != tableType) {
                    /**Load blocker to prevent the changes from triggering a table refresh **/
                    fundExplorer.loadVars.hasLoaded = false;
                    /*we need to switch the table type*/
                    $('#intestmentType').find("[value='" + tableType + "']").click();

                    /* switch to overview regardless */
                    $('.fund-explorer-table__view--dropdown').find("[value='ov']").click();
                    fundExplorer.loadVars.hasLoaded = true;
                }

            /*Search requires the InvType dropdown to be "All" */
                var originalInvType = $('#investment-type > .dropdown__label').text(); //this should be before it switches to all.
                originalInvType != "All" ? $('#investment-type > .dropdown__label').data('orig-inv-type', originalInvType): false ; //to make sure it is not already switched to all.
                $('#investment-type > .dropdown__label').text('All');


            }

            txdata = {
                'filterJson':
                    `{
                        "InvType":"${fundExplorer.InvType}",
                        "AssetClass":[${assetClasses}],
                        "Funds":[${Funds}],
                        "ShareClass":[${shareClasses}],
                        "TableType":"${fundExplorer.TableType}",
                        "SortCol":"ticker",
                        "isasc":true,
                        "FilterFunds":["${searchTerm}"],
                        "CurrentPageId":"${window.config.currentPageId}",
                        "CountryIso":"${fundExplorer.CountryIso}",
                        "LanguageIso":"${fundExplorer.LanguageIso}",
                        "InvestorType":"${fundExplorer.InvestorType}"
                    }`
            };
        }

        //console.log(txdata);

        feutils.spinner.show();
        //console.time('Ajax load');

        if (!isGet) {
            $.post(url, txdata).done(function(data, response) {
                fundExplorer.executeData(data, response);
            }).fail(function(err){fundExplorer.ajaxFail(err)});
        } else {
            $.get(url).done(function(data, response) {
                fundExplorer.executeData(data, response);
            }).fail(function (err) { fundExplorer.ajaxFail(err) });
        }

    },

    executeData: function (data, response) {
        if (typeof data == "object" && typeof data.Result == "object") {
            var data = data.Result;
            fundExplorer.currentdata = data;
            //console.timeEnd('Ajax load');
        } else {
            var data = fundExplorer.currentdata;
        }

        var response = response || false;

        //console.log(fundExplorer.currentdata);

        if (response) {
            //console.log("Skipping render of table and sorting instead first.");

            fundExplorer.sortData();
            return false;
        }

        //console.time("Table render");

        /* Finally render the table! */
        fundExplorer.rnTable(fundExplorer.currentdata);

        feCharts.activateTabListeners();
        fundExplorer.rnExcelDownloadLink();

        //console.timeEnd("Table render");
        fundExplorer.asOfDate = data.AsOfDate;
        //fundExplorer.refreshAllLabels();
        fundExplorer.fundCountRefresh(data.AsOfDate);
    },

    ajaxFail: function(error) {
        console.error('Response had an error: ');
        console.log(error);
        console.timeEnd('Ajax load');
        feutils.spinner.hide();
    },


    /**
     * /
     * Takes in the table data (currentData) and renders the table.
     */
    rnTable: function(data) {
        if (typeof data != "object" || data === null) {
            console.error("A dataset is needed to render the table");
            return false;
        }
        if (typeof data.Headers != "object") {
            console.error("Headers are needed to render the table");
            return false;
        }

        /* 1. Rendering the desktop table */
        var drawslr = "#desktop-draw-area";
        var tableslr = ".fund-listing-table.table-desktop";
        const firstLoad = $(".fund-listing-table").text().trim() == ''; //if first load will return empty string
        $(drawslr).empty();
        $(drawslr).append(
            '<table id="overview" class="table fund-listing-table table-desktop"><thead><tr></tr></table>');

        fundExplorer.rnTableHeaders(data.Headers, tableslr);
        fundExplorer.rnTableBody(data.Headers, data.FundSet, tableslr);


        /* 2. Rendering the mobile table */
        var smdrawslr = "#mobile-draw-area";
        var smtableslr = ".fund-listing-table.table-mobile";

        $(smdrawslr).empty();
        $(smdrawslr).append('<div id="overview" class="fund-listing-table table-mobile"></div>');

        fundExplorer.rnMobileTable(data.Headers, data.FundSet, smtableslr);

        //if first load it is called on the generic promo banner line 31
        //this is to prevent the issue with the fundd explorer table header
        if (firstLoad) {
            setTimeout(() => {
                floatThread();
                loadEvents();
            }, 1000)
        } else {
            floatThread();
            loadEvents();
        }

        fundExplorer.bindchangeEvent();
        fundExplorer.applySortListeners();
        feutils.spinner.hide();
    },

    exportExcel: function () {
        feutils.spinner.show();

        /* 1. Rendering the Excel table */
        var xldrawslr = "#excel-draw-area";

        console.time('excel-table');
        fundExplorer.rnExcelTable(xldrawslr);
        console.timeEnd('excel-table');

        feutils.fnExcelReport('export-excel-table');

        feutils.spinner.hide();
    },

    /**
     *
     *
     * Takes in the table headers and renders them appropriately.
     */
    rnTableHeaders: function(headers, tableslr) {
        if (!typeof headers == "object") {
            console.error("Headers were not defined.");
            return false;
        }
        //create a new header row
        var mkheaders = "";



        headers.forEach(function (header, i) {

            //if header is to be hidden in mobile, don't bother rendering
            if (header.MobileOnly) {
                //console.log("Item '" + header.Name + "' ignored on desktop table");
                return "";
            }

            //if sortable then show icon
            var sortIcon = (header.Sortable && fundExplorer.currentdata.FundSet.length != 1) ? feutils.getSvg("sortIconDefault") : "";

            //These items would change if it were a compound item.
            var headerClassName = header.HeaderClassName || "";
            var subItems = "";
            var sortHeaderClass = (header.Sortable && fundExplorer.currentdata.FundSet.length != 1) ? "sortable" : "";
            var attribs = 'data-header="' + header.Name + '"';

            //if compound, then render the sorting feature
            if (header.Template == "compound" && header.ClassName.indexOf("default-sort") < 0) {
                headerClassName += " justify-content-center ";
                sortIcon = (header.Sortable && fundExplorer.currentdata.FundSet.length != 1) ? feutils.getSvg("sortIconCompound") : "";
                subItems = '<div class="sort-thead-content">';

                if (typeof header.SubHeaders != "object") {
                    console.error('SubHeaders are not defined for header ' + header.Name);
                    subItems = "";
                } else {

                    header.SubHeaders.forEach(function (sub, j) {
                        var subDisplayName = sub.DisplayName.replace(/( \(%\))/, ""); //remove the percentages
                        subItems += '<span>' +
                            subDisplayName +
                            '</span> <div class="mb-2 form-check"><input type="radio" name="2011-name-annual-returns" id="DESC-' +
                            header.Name +
                            "-" +
                            sub.Name +
                            '" class="form-check-input header-sort-radio" data-header="' + sub.Name + '" data-order="DESC" /><label for="DESC-' +
                            header.Name +
                            "-" +
                            sub.Name +
                            '" class="form-check-label">High to Low</label></div ><div class="mb-2 form-check"><input type="radio" name="2011-name-annual-returns" id="ASC-' +
                            header.Name +
                            "-" +
                            sub.Name +
                            '" class="form-check-input header-sort-radio" data-header="' + sub.Name + '" data-order="ASC" /><label for="ASC-' +
                            header.Name +
                            "-" +
                            sub.Name +
                            '" class="form-check-label">Low to High</label></div>';
                    });
                    sortHeaderClass = "sort-thead";
                    subItems += "</div>";

                }

                if (!header.Sortable || fundExplorer.currentdata.FundSet.length == 1) {
                    subItems = "";
                }

            }

            //render the innerHtml of the header.
            var headerText = '<div class="align-items-center sort-table-thead ' +
                headerClassName +
                '"><span class="table-thead">' +
                header.DisplayName +
                sortIcon +
                '</span>' +
                subItems +
                '</div>';

            var id = header.Name + "-header";

            mkheaders += feutils.rnCode('th', headerText, id, sortHeaderClass, attribs);

        });

        $(tableslr + " > thead > tr").append(mkheaders);
    },

    bindchangeEvent: function() {
        $(".openLinkInNewTab").on("click", function () {
            if (this.value && this.value.toLowerCase != 'select') {
                window.open(this.value, '_blank').focus();
                this.selectedIndex = 0;
            }
        });


        if ($(".dropdown-container.dropdown.bs4-dropdown").length > 0) {
            const closeAllDropdowns = function () {
                $(".dropdown-container.dropdown.bs4-dropdown.show").dropdown("toggle");
                window.removeEventListener("scroll", closeAllDropdowns);
            }

            $(".dropdown").on("shown.bs.dropdown", function () {
                window.addEventListener("scroll", closeAllDropdowns);
            });
        }

    },

    /*
     *	Takes in table data (headers + body) and renders the body.
     */
    rnTableBody: function(headers, fundSet, tableslr) {
        var mktable = "<tbody>";
        fundSet.length < 1 ? $("body").addClass("no-results") : $("body").removeClass("no-results");

        fundSet.forEach(function(fund, i) {

            mktable += "<tr id='" + fund.FundID + "-row'>";
            var mkrows = "";
            var expandableContent = "";

            headers.forEach(function(header, x) {
                var row = fund.RowData.find(function(e, h) {
                    return e.Header == header.Name;
                });
                mkrows += fundExplorer.rnCell(header, fund.FundID, row);

                //if it is an 'exandable' item, we need to generate an entire row for it.
                if (header.Template === "expandable") {
                    expandableContent += fundExplorer.rnExpandableRow(header, fund.FundID, row, headers.length);
                }
            });
            mktable += mkrows + "</tr>";
            mktable += expandableContent;

        });
        return $(tableslr).append(mktable + "</tbody");
    },

    rnCell: function(header, fundid, fund) {
        if (typeof fund === "undefined") {
            console.error("Cell data matching the header '" + header.Name + "' was not found for " + fundid);
            return "<td></td>";
        }

        if (header.MobileOnly) {
            return "";
        }

        var markup = "";
        var classes = fund.ClassName || fund.CustomClass || header.ClassName || "";
        var attribs = "";
        var lnattrib = fund.LinkTarget ? 'target="' + fund.LinkTarget + '"' : "";
        switch (header.Template) {
            case "card":
                if (typeof fund.CardData != "object" || fund.CardData === false || typeof  fund.CardData.MorningStarRating != "string") {
                    //console.log("Could not find card/MorningStar data for " + fundid + " -> " + header.Name + " rendering as text instead.");
                    markup = fund.Link ? '<a href="' + fund.Link + '" ' + lnattrib + ' >' + fund.DisplayValue + '</a>' : fund.DisplayValue;
                    break;
                }
                if (fund.CardData.Description === "" && fund.CardData.MorningStarRating === ""){
                    markup = fund.Link ? '<a href="' + fund.Link + '" ' + lnattrib + ' >' + fund.DisplayValue + '</a>' : fund.DisplayValue;
                    break;
                }
                var cardLink = fund.Link ? fund.Link : "#";
            var cardID = fundid + '-' + fund.Header;
            //Need to only display the infoIcon if it is the name
            var infoIcon = header.Name.toLowerCase() === "name" ? "  <span class='more-info-icon-svg'>" + feutils.getSvg("infoIcon") + "</span>" : "";

            markup = '<a class="fund-explorer-table-tooltip-item" href="' + cardLink + '" data-target="#' +
                cardID +
                '" id="' +
                cardID +
                '-link" >' +
                fund.DisplayValue + infoIcon +
                '</a >' +
                fundExplorer.rnCard(fund.CardData, cardID);
            classes += " fund-explorer-table-tooltip ";
            break;
            case "text":
                /**
                 * Need to check if there is a up/down arrow before rendering the item.
                 */
                if (classes.indexOf("up-arrow") === -1 && classes.indexOf("down-arrow") === -1) {
                    fund.DisplayValue = fund.DisplayValue == "PDF" && fund.Link ? `<img class="download-icon" src="/globalassets/home/us/etf/default-link-icon.svg" alt="download icon">` : fund.DisplayValue;
                    markup = fund.Link
                        ? '<a href="' + fund.Link + '" ' + lnattrib + ' >' + fund.DisplayValue + '</a>'
                        : fund.DisplayValue;
                } else {
                    var svgClass = "";
                    var svgMarkup = "";
                    if (classes.indexOf("up-arrow") > -1) {
                        svgClass += " fund-explorer-table__chevron-up ";
                        svgMarkup += feutils.getSvg('up');
                    }
                    else {
                        svgClass += " fund-explorer-table__chevron-down ";
                        svgMarkup += feutils.getSvg('down');
                    }
                    markup = svgMarkup + ' <span class="' + svgClass + '">' + fund.DisplayValue + '</span>';
                }

            break;
        case "CTA":
            var anchor = fund.Link
                ? '<a class="cta-link" href="' + fund.Link + '" ' + lnattrib + ' >'
                : '<a class="cta-link" href="#" target="tr">';
            var span = '<span class="cta-link__text text-util-md">';
            var svg =
                '<svg aria-hidden="true" focusable="false" data - prefix="far" data - icon="angle-right" class="svg-inline--fa fa-angle-right fa-w-16 fa-lg cta-link__icon align-middle" role = "img" xmlns = "http://www.w3.org/2000/svg" viewBox = "0 0 24 24" > <path fill="currentColor" d="M10 7.25a.75.75 0 00-.53.22.75.75 0 000 1.06L12.94 12l-3.47 3.47a.75.75 0 000 1.06.75.75 0 001.06 0l4-4a.75.75 0 000-1.06l-4-4a.75.75 0 00-.52-.22z"></path></svg >';
            markup = anchor + span + fund.DisplayValue + '</span>' + svg + '</a>';
                break;

        case "html":
            if (fund.Html === null) {
                console.error("Html was not provided for a html template cell.");
                markup = "";
                break;
            }
            markup = fund.Html;
                break;

        case "compound":
            if (typeof fund.SubItems != "object" || fund.SubItems.length == 0) {
                console.error("SubItems not provided for compound template:" + header.Name);
                markup = "";
                break;
            }
            fund.SubItems.forEach(function(sub, j) {
                subClasses = sub.ClassName || classes || "";
                var svgClass = "";
                if (subClasses.indexOf("up-arrow")>-1) {
                    svgClass += " fund-explorer-table__chevron-up ";
                    markup += "<div>" + feutils.getSvg('up');
                }
                else if (subClasses.indexOf("down-arrow")>-1) {
                    svgClass += " fund-explorer-table__chevron-down ";
                    markup += "<div>" + feutils.getSvg('down');
                } else {
                    markup += "<div>";
                }
                markup += '<span class="' + subClasses + '">' + sub.DisplayValue + '</span><span class="' + svgClass + '"></span></div>';
                if (j + 1 < fund.SubItems.length && classes.indexOf("no-divider") < 0) {
                    var margin = classes.indexOf("flush-left") > -1 ? "ml-0" : "";
                    markup += '<hr class="fund-explorer-table__divider ' + margin + '" />';
                }
            });
                break;

            case "expandable":
                var DisplayValue = fund.DisplayValue || "Show Chart";
                var HideValue = fund.HideValue || "Hide Chart";
                markup +=
                    '<div class="fund-explorer-table__view-data-container"><a target="tr" href="#' + fundid + header.Name + '-expandable" index="0" data-toggle="collapse" data-target="#' + fundid + header.Name + '-expandable" aria-controls="#' + fundid + header.Name + '-expandable" class="fund-explorer-table__data-link fund-explorer-expandable icon-plus collapsed cta-link"><span class="accordion-text accordion-text-hidden text-util-md">' + DisplayValue + '</span><span class="accordion-text accordion-text-shown text-util-md">' + HideValue + '</span><svg aria-hidden="true" focusable="false" data-prefix="fa" data-icon="plus" class="svg-inline--fa fa-plus fa-w-14 fa-sm icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"> <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"> </path> </svg></a></div>';
                break;

        default:
            markup = "";
            console.error("The template type '" + header.Template + "' is not supported yet.");
            break;
        }
        return feutils.rnCode("td", markup, false, classes, attribs);
    },

    rnExpandableRow: function (header, FundID, row, colCount) {
    /** Content could be either html or a chart to be rendered. To be coded later */
        if (typeof row.ExpandableContent != "object") {
            return console.error("The header " + header.Name + " is an expandable one but there is no ExpandableContent defined for " + FundID);
        }
        if (row.ExpandableContent.ChartTemplate && typeof row.ExpandableContent.ChartTemplate === "string") {
            var content = feCharts.rnChartArea(row.ExpandableContent.ChartTemplate, row);
            return '<tr> <td colSpan="' + colCount + '" style="padding:0"> <div class="collapse expandable-content-pane" id="' + FundID + header.Name + '-expandable"> <div class="pt-4 pl-3 pr-3 expandable-layout-body">' + content + '</div> </div> </td> </tr>';;
        }

        if (typeof row.ExpandableContent.Html == "string") {
            return row.ExpandableContent.Html;
        }

        console.error("Could not rendeer expandable content for " + header.NAMESPACE_RULE + " for the fund " + FundID);
        return "";
    },

    /*
     *	Takes in table data (headers + body) and renders the mobile body.
     * The header row of the body consists of the name and ticker if available.
     */
    rnMobileTable: function (headers, fundSet, tableslr) {
        //debugger;
		var mktable = '';
        fundSet.forEach(function (fund, i) {
            //For compound items, we might need to find if there is a label item defined for each row.
            var labels = fundExplorer.getLabelsFromRowData(fund.RowData);


			var mkrow = "<div class='fund-explorer-table__card' id='" + fund.FundID + "-mobile-card'>";
			var mkheader = "<div class='fund-explorer-table__card-header row' id='" + fund.FundID + "-mobile-header'>";
			var mkbody = "<div class='row' id='" + fund.FundID + "-mobile-row'>";

            headers.forEach(function (header, x) {
                var row = fund.RowData.find(function (e, h) {
                    return e.Header == header.Name;
                });

                row.compositeHeaders = labels;

				isHeaderItem = (header.Name.toLowerCase() == "ticker" || header.Name.toLowerCase() == "name");
				if (isHeaderItem) {
                    mkheader += fundExplorer.rnMobileCell(header, fund.FundID, row, true);
                } else {
                    mkbody += fundExplorer.rnMobileCell(header, fund.FundID, row, false);
                }

            });
            mktable += mkrow + mkheader + "</div>" + mkbody + "</div>" + "</div>";
        });
        return $(tableslr).append(mktable);
	},


    rnMobileCell: function (header, fundid, fund, isHeader) {
        if (typeof fund === "undefined") {
            console.error("Cell data matching the header '" + header.Name + "' was not found for " + fundid);
            return "<div></div>";
		}
        if (header.DesktopOnly) {
            //console.log("Item '" + header.Name + "' ignored on mobile table for " + fundid);
            return "<div></div>";
        }

        var markup = "";
        var classes = fund.CustomClass || fund.ClassName || "";
        var headerClasses = header.ClassName || "";
        var attribs = "";
        var lnattrib = fund.LinkTarget ? 'target="' + fund.LinkTarget + '"' : "";

		if (isHeader) {
            var link = fund.Link || "#";

            switch(header.Name.toLowerCase()) {
                case "ticker":
                    return '<div class="fund-explorer-table__card-ticker col-2"' + classes + '"><a ' + lnattrib + ' href="' + link + '">' + fund.DisplayValue + '</a></div>';
				case "name":
                    return '<div class="fund-explorer-table__card-name col-10"' + classes + '"><a ' + lnattrib + ' href="' + link + '">' + fund.DisplayValue + '</a></div>';
				default:
                    console.error(header.Name + "was identified as a header, but cannot be rendered on the mobile card.");
                    return "";
			}
        }

		/* It is not a header section of the card -- ie !name && !ticker */
        classes += " fund-explorer-table__card-body col-md-3 col-6";

        switch (header.Template) {
        case "card":
            case "text":
                var displayName;
                //Check if the arrows and color need to be added, if not the text is plain.
                if (classes.indexOf("up-arrow") === -1 && classes.indexOf("down-arrow") === -1) {
                    displayName = fund.DisplayValue;
                } else {
                    var svgClass = "";
                    var svgMarkup = "";
                    if (classes.indexOf("up-arrow") > -1) {
                        svgClass += " fund-explorer-table__chevron-up ";
                        svgMarkup += feutils.getSvg('up');
                    } else {
                        svgClass += " fund-explorer-table__chevron-down ";
                        svgMarkup += feutils.getSvg('down');
                    }
                    displayName = svgMarkup + " <span class='" + svgClass + "'>" + fund.DisplayValue + "</span>";
                }

                innerHtml = fund.Link ? '<a href=' + fund.Link + ' ' + lnattrib + ' >' + displayName + '</a>' : displayName;
            markup = '<div class="fund-explorer-table__card-column ' + headerClasses + '">' + header.DisplayName + '</div>' +
                    '<div class="fund-explorer-table__card-data">' + innerHtml + '</div >';

            break;
			case "CTA":
                markup = '<a class="cta-link fund-explorer-table__card-data" href="' + (fund.Link ? fund.Link : "#") + ' ' + lnattrib + '"><span class="cta-link__text text-util-md">' + fund.DisplayValue + '</span><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="angle-right" class="svg-inline--fa fa-angle-right fa-w-16 fa-lg cta-link__icon align-middle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"> <path fill="currentColor" d="M10 7.25a.75.75 0 00-.53.22.75.75 0 000 1.06L12.94 12l-3.47 3.47a.75.75 0 000 1.06.75.75 0 001.06 0l4-4a.75.75 0 000-1.06l-4-4a.75.75 0 00-.52-.22z"></path></svg></a>';
                break;
        case "html":
            if (fund.Html === null) {
                console.error("Html was not provided for a html template cell."); return false;
            }
            markup = fund.Html;
            break;
        case "compound":
            if (typeof fund.SubItems != "object" || fund.SubItems.length == 0) {
                    console.error("SubItems not provided for compound template:" + header.Name); markup = ""; break;
				}
				markup += '<div class="fund-explorer-table__card-column ' + headerClasses + '">' + header.DisplayName + '</div>';
				fund.SubItems.forEach(function (sub, j) {
                    subClasses = sub.ClassName || "";

                    markup += '<div class="fund-explorer-table__card-data">';

                    if (subClasses.indexOf("up-arrow") > -1) {
                        subClasses += " fund-explorer-table__chevron-up ";
                        markup += feutils.getSvg('up');
                    }
                    else if (subClasses.indexOf("down-arrow") > -1) {
                        subClasses += " fund-explorer-table__chevron-down ";
                        markup += feutils.getSvg('down');
                    }

                    var subHeaderName =
                        (typeof fund.compositeHeaders === "object" && typeof fund.compositeHeaders[j] === "string")
                            ? fund.compositeHeaders[j]
                            : header.SubHeaders[j].DisplayName;

                    markup += '<span>' + sub.DisplayValue + '</span><span class="' + subClasses + '"></span> ' + subHeaderName + '</div>';
				});
            break;
        case "expandable":
		    /* Exapndables are not rendered on mobile */
            return " ";
        default:
            markup = "";
            console.error("The template type '" + header.Template + "' is not supported yet.");
            break;
        }
        return feutils.rnCode("div", markup, false, classes, attribs);
    },

    rnCard: function (cardData, cardId) {

        if (typeof cardData != "object" || cardData === null) {
            console.error("Card Data not provided for" + cardId); return false;
        }

        if (cardData.MorningStarRating !== "") {
        /* Get the first character of the morningstar data */
            var mRating = !isNaN(cardData.MorningStarRating.slice(0, 1)) ? Number(cardData.MorningStarRating.slice(0, 1)) : 1;

            var starSvg = feutils.getSvg('morningstar');

            var morningstarMarkup =
                '<div class="d-flex mb-3"><div>' + starSvg.repeat(mRating) + '</div> <div class="ml-1"> <div class="fund-explorer-block__rating-description">Overall Morningstar Rating</div> <div class="fund-explorer-block__rating-in-words">' +
                    cardData.MorningStarRating +
                    '</div> </div> </div>';
        } else {
            var morningstarMarkup = "";
        }

        return cardData.Description === ""
            ? '<div class="fund-explorer-table-tooltip-content" id="' + cardId + '" style="display:none"><div class="fund-explorer-block w-100"><h5 class="mb-0">' + cardData.Ticker + '</h5><div class="mb-2">' + cardData.FundName + '</div> ' + morningstarMarkup + ' <div class="d-flex"> <div class="fund-explorer-block__info-title">Asset Class</div> <div class="fund-explorer-block__info-description">' + cardData.AssetClass + '</div> </div> <div class="d-flex"> <div class="fund-explorer-block__info-title">Category</div> <div class="fund-explorer-block__info-description">' + cardData.Category + '</div> </div>' + cardData.Description + ' <div class="fund-explorer-block__details mt-4 ">'+ fundMorningstarDisclosure.disclosureText + '</div> </div> </div >'
            : '<div class="fund-explorer-table-tooltip-content" id="' + cardId + '" style="display:none"><div class="fund-explorer-block w-100"><div>'+ cardData.Description + '</div> </div> </div >';

    },

    /*
     * Function that renders the hidden excel table without any fancy formatting.
     */
    rnExcelTable: function (tableslr) {
        var headers = fundExplorer.currentdata.Headers;

        var fundSet = fundExplorer.currentdata.FundSet;

        var mktable = "<table id='export-excel-table'>";

        var mkheader = "<thead id='xl-header'><tr>";

        headers.forEach(function (header, x) {
            if (header.Template === "expandable" || header.MobileOnly || header.SkipExcel) {
                var mkHeaderRow = "";
                //console.log("Item '" + header.Name + "' ignored on excel table");
            } else {
                var mkHeaderRow = "<th style='border: 1px solid #BBB;'>" + header.DisplayName + "</th>";
            }
            mkheader += mkHeaderRow;
            });

            mkheader += "</tr></thead>";

            var mkrow = "<tbody>";

            fundSet.forEach(function(fund, i) {
                mkrow += "<tr>";

                headers.forEach(function(header, x) {
                    var row = fund.RowData.find(function(e, h) {
                        return e.Header == header.Name;
                    });

                    mkrow += fundExplorer.rnExcelCell(header, fund.FundID, row);

                });

                mkrow += "</tr>";

            });

            mkrow += "</tbody>";

        mktable += mkheader + mkrow + "</table>";

        $(tableslr).empty();

        return $(tableslr).append(mktable);
    },

    rnExcelCell: function(header, fundid, fund, isHeader) {
        if (typeof fund === "undefined") {
            console.error("Cell data matching the header '" + header.Name + "' was not found for " + fundid);
            return "<td style='border: 1px solid #BBB;'></td>";
        }
        if (header.MobileOnly || header.SkipExcel || header.Template === "expandable") {
            return "";
        }

        switch (header.Template) {
        case "compound":
            if (typeof fund.SubItems != "object" || fund.SubItems.length == 0) {
                console.error("SubItems not provided for compound template:" + header.Name);
                markup = "";
                break;
            }

            var markup = "";

            fund.SubItems.forEach(function(sub, j) {

                markup += '<div>' + sub.DisplayValue + '</div>';

            });
            break;
            default:
                var link = fund.Link ? new URL(fund.Link, document.baseURI).href : false;
                var markup = link ? '<a href=' + link + '>' + fund.DisplayValue + '</a>' : fund.DisplayValue;;
        }
        return "<td style='border: 1px solid #BBB;'>" + markup + "</td>";
    },

    getHeader: function (headerName, notMobileOnly) {
        return fundExplorer.currentdata.Headers.find(function (h) {
            return (h.Name.toLowerCase() === headerName.toLowerCase()) && !(notMobileOnly && h.MobileOnly);
        });
    },

    getSubHeader: function (headerName, notMobileOnly) {
        if (typeof headerName === "undefined") return false;
        return fundExplorer.currentdata.Headers.find(function (h) {
            if (typeof h.SubHeaders === "undefined" || h.SubHeaders == null) return false;
            return h.SubHeaders.find(function(s) {
                return (s.Name.toLowerCase() === headerName.toLowerCase()) && !(notMobileOnly && h.MobileOnly);
            });
        });
    },

    getCellFromRowData: function (rowData, headerName) {
        if (typeof rowData != "object" || typeof headerName != "string") return false;
        return rowData.find(function(column) {
            return (column.Header.toLowerCase() === headerName.toLowerCase());
        });
    },

    getLabelsFromRowData: function (rowData) {
        if (typeof rowData != "object") return false;
        var labels = fundExplorer.getCellFromRowData(rowData, "labels");
        if (!labels) return false;
        if (typeof labels.SubItems === "undefined" || labels.length == 0) return false;

        return labels.SubItems.map(function (x) {
                return x.DisplayValue;
        });
    },

    /**
     * /
     * Main sort data function which takes in header, sorts appropriately and renders it.
     */
    sortData: function (header, isAsc) {
        if (typeof isAsc === "undefined") isAsc = true; /* True -- ascending by default if unspecified */

        header = header || (fundExplorer.SortHeader != "" ? fundExplorer.SortHeader : undefined);
        isAsc = isAsc || ((header === fundExplorer.SortHeader) ? (fundExplorer.SortDesc === true ? false : true) : false);

        var Mainheader = false;

        if (typeof header != "string" || !fundExplorer.getHeader(header)) {
                /**
                 * Try Subheaders
                 */
            Mainheader = fundExplorer.getSubHeader(header, true); //this returns the main header of the subheader.

            if (!Mainheader) {
                //console.log("Sort header not provided or not found... defaulting to name or ticker");
                header = fundExplorer.getHeader("name", false) ? fundExplorer.getHeader("name", false).Name : (fundExplorer.getHeader("ticker", true) ? (fundExplorer.getHeader("ticker", true).Name) : false);

                if (header === false) {
                    console.error("Can't sort by name or ticker and no sort header provided on desktop!");
                    return false;
                }
            }
        }

        //isDesc = isDesc ? true : false;
        var data = fundExplorer.currentdata;

        /**
        * From this point on, we have two scenarios.
        *
        * If typeof MainHeader != undefined
        *      then MainHeader is the main header and header is the subheader.
        *      This is the compound header scenario.
        *
        * If typeof MainHeader == undefined
        *      then header is the header, and we are not looking for a subheader.
        *      This is the standard header scenario.
        */

        var headerToSearch = Mainheader ? Mainheader.Name.toLowerCase() : header;

        /* Find by the headers and dump the sort value */
        data.FundSet.forEach(function(e, i) {
            var cell = e.RowData.find(function (x, h) {
                return x.Header.toLowerCase() === headerToSearch.toLowerCase();
            });

            if (typeof cell == "undefined") {
                console.error("Sort data " + headerToSearch + " not found for " + e.FundID);
                return false;
            }

            //Remove the percentages and the commas before converting to number
            var rexEx = /([,%])+/;

            if (Mainheader) {
                if (typeof cell.SubItems != "undefined") {
                    var subcell = cell.SubItems.find(function (s) {
                        return s.Header.toLowerCase() === header.toLowerCase();
                    });
                }
                if (typeof subcell != "undefined" && typeof subcell.Value != "undefined") {
                    var cellValue = subcell.Value;
                } else {
                    var cellValue = 0;
                }

            } else {
                var cellValue = cell.Value;
            }

            cellValue = String(cellValue).replace(rexEx, "");
            data.FundSet[i].sortValue = isNaN(cellValue) ? cell.Value : Number(cellValue);
        });

        data.FundSet.sort(function (a, b) {
            if (!isNaN(a.sortValue) && !isNaN(b.sortValue)) {
                return isAsc ? b.sortValue - a.sortValue : a.sortValue - b.sortValue;
            }

            //one of them are strings then, therefore we have to do a string comparision.
            var nameA = a.sortValue.toUpperCase(); // ignore upper and lowercase
            var nameB = b.sortValue.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
                return isAsc ? -1 : 1;
            }
            if (nameA > nameB) {
                return isAsc ? 1 : -1;
            }

            // names must be equal
            return 0;

        });

        fundExplorer.currentdata = data;
        fundExplorer.SortHeader = header;
        fundExplorer.SortDesc = isAsc;
        fundExplorer.createFundUrl();

        $('.fund-explorer-table th.underlined').removeClass('underlined');

        headerslr = Mainheader ? '.fund-explorer-table #' + Mainheader.Name + '-header' :  '.fund-explorer-table #' + header + '-header';

        fundExplorer.executeData();
        var sortORder = isAsc ? "ASC" : "DESC";
        fundExplorer.currentdata.FundSet.length > 1 ? $(headerslr).data('sort-order', sortORder).addClass('underlined') : false;

        if (Mainheader) {
            /**
             * Intentionally flipped because there is something inversed above.
             */
            sortORder = isAsc ? "DESC" : "ASC";
            $(".fund-explorer-table #" + sortORder + "-" + Mainheader.Name + "-" + header).prop("checked", true);
        }

    },

    applySortListeners: function() {
        $('.fund-explorer-table #desktop-draw-area th.sortable').click(function () {
            var header = $(this).data('header');
            /** Should be Ascending if the current order is descending or if undefined. */
            var isAsc = $(this).data('sort-order') == "DESC" || typeof $(this).data('sort-order') === "undefined";

            if (header === fundExplorer.SortHeader) {
            /*If it is the same header, set the global variable accordingly so the sort is reversed
             As this is a click, it is to be reversed */
                fundExplorer.sortDesc = !isAsc;
            }

            fundExplorer.sortData(header, isAsc);

        });

        $(".header-sort-radio").click(function () {
            var header = $(this).data("header");
            /** Intentionally flipped because there is something inversed in the sort function. */
            var order = $(this).data("order") === "DESC";
            fundExplorer.sortData(header, order);
        })

    },

    retrieveAllFundsData: function() {

        /**
         * Get the full list of funds and tickers for the fund count as well as for search autocomplete.
         */
        allData = {
            'filterJson':
                `{
                    "InvType":"all",
                    "AssetClass":[],
                    "Funds":[],
                    "ShareClass":[],
                    "TableType":"search",
                    "CurrentPageId":"${window.config.currentPageId}",
                    "CountryIso":"${fundExplorer.CountryIso}",
                    "LanguageIso":"${fundExplorer.LanguageIso}",
                    "InvestorType":"${fundExplorer.InvestorType}"
                }`
        };

        url = "/Main/FundListingUs/GetFundData";
        if (window.location.search) {
            var searchParams = new URLSearchParams(window.location.search);
            var latest = searchParams.get("latest");
            var epiProjects = searchParams.get("epiprojects");
            if (latest){
                url = url + `${url.indexOf("?") !== -1 ? "&" : "?"}latest=${latest}`;
            }

            if (epiProjects) {
                url = url + `${url.indexOf("?") !== -1 ? "&" : "?"}epiprojects=${epiProjects}`;
            }
        }

        fundExplorer.allTickers = {
            etf: [],
            mf: []
        };

        $.post(url, allData).done(function (data) {
            data.Result.FundSet.forEach(function(e, i) {
                fundExplorer.allTickers[e.TickerGroup.toLowerCase()].push({
                    id: e.FundID,
                    value: e.FundID,
                    name: e.FundName,
                    fundType: e.TickerGroup.toLowerCase()
                });
            });
            fundExplorer.autocomplete.activate();
            fundExplorer.fundCountRefresh();
        });


    },

    autocomplete: {
        activate: function () {

            if (typeof fundExplorer.allTickers === "undefined") return;

            var invType = fundExplorer.InvType || "etf";
            var autocompleteSlr = ".fund-explorer-screener__dropdown > .input-group > input";

            fundExplorer.autocomplete.destroy();

            var alltickers = fundExplorer.allTickers.etf.concat(fundExplorer.allTickers.mf);

            $(autocompleteSlr).autocomplete({
                minLength: 2,
                //autoFocus: true,
                source: alltickers,
                    classes: {
                        "ui-autocomplete": "ui-autocomplete-tickers",
                    },
                    focus: function(event, ui) {
                        $(autocompleteSlr).val(ui.item.id);
                        return false;
                    },
                select: function (event, ui) {
                    fundExplorer.autocomplete.select(ui, false);
                    return false;
                }
                })
                .autocomplete("instance")._renderItem = function (ul, item) {
                    var id = String(item.id).replace(
                        new RegExp(this.term, "gi"),
                        "<span class='ui-state-highlight'>$&</span>");
                    var name = String(item.name).replace(
                        new RegExp(this.term, "gi"),
                        "<span class='ui-state-highlight'>$&</span>");
                    return $("<li class='dropdown-item dropdown__item text-util-sm'>")
                        .append("<div>" + id + "<br>" + name + "</div>")
                        .appendTo(ul);
                };
            $(autocompleteSlr).autocomplete("instance")._resizeMenu = function() {
                this.menu.element.outerWidth($(autocompleteSlr).outerWidth());
            }
            /* Listen for when the user presses Enter */
            $(autocompleteSlr).keypress(function(e) {
                if (e.which === 13) {
                    var term = $(this).val();
                    fundExplorer.autocomplete.search(term);
                    $(".ui-autocomplete-tickers").hide();
                    if (isInterentExplorerDevice) {
                        window.setTimeout(function() {$(".fund-explorer-table__view--dropdown .dropdown__menu.show").click();}, 5);
                    }
                }
            });
        },

        destroy: function () {
            var autocompleteSlr = ".fund-explorer-screener__dropdown > input";
            if ($(autocompleteSlr).data('autocomplete')) {
                $(autocompleteSlr).autocomplete("destroy");
                $(autocompleteSlr).removeData('autocomplete');
            }
        },

        select: function (ui, dontLoad) {
            var autocompleteSlr = ".fund-explorer-screener__dropdown > .input-group > input";
            $(autocompleteSlr).val(ui.item.id).after(feutils.getSvg("searchButton")).prop("disabled", true);
            $(".dropdown-checkbox-button, .dropdown__button#investment-type").addClass('disabled');
            fundExplorer.autocomplete.search(ui.item.id, dontLoad);
            return false;
        },

        search: function (term, dontLoad) {
            if (typeof term === "undefined" || term === "") {console.error("Search term not specified, ignoring."); return;}
            fundExplorer.SearchTerm = term;
            !dontLoad ? fundExplorer.loadData() : false;
            fundExplorer.autocomplete.bindReset();
            return false;
        },

        bindReset: function () {

            var autocompleteSlr = ".fund-explorer-screener__dropdown > .input-group > input";
            $(".fund-explorer-screener__dropdown > .input-group > .input-group-append > .btn").click(function() {
                fundExplorer.SearchTerm = "";
                fundExplorer.loadData();
                $(autocompleteSlr).prop("disabled", false).val("");
                $(".dropdown-checkbox-button, .dropdown__button#investment-type").removeClass('disabled');
                $('#investment-type > .dropdown__label').text($('#investment-type > .dropdown__label').data('orig-inv-type'));
                $(".fund-explorer-screener__dropdown > .input-group > .input-group-append").remove();

            });
        }
    },

    rnExcelDownloadLink: function () {
        if (fundExplorer.currentdata.DisableExcelDownload) {
            $('.fund-explorer-table__download-excel').text('');
            return;
        }
        $('.fund-explorer-table__download-excel').text('Download Excel');
    },

    fundCountRefresh: function (asofdate) {
        if (typeof fundExplorer.allTickers === "undefined" || typeof fundExplorer.currentdata === "undefined") return;

        const asOfDatePlaceholder = fundExplorer.translations[fundExplorer.translationKeys.AsOfDate];
        const showingPlaceholder = fundExplorer.translations[fundExplorer.translationKeys.ShowingFunds];

        asofdate = asofdate || fundExplorer.asOfDate;
        let asOfDateObject = new Date(asofdate);
        if (asOfDateObject instanceof Date && isNaN(asOfDateObject) && asofdate.includes('/')) {
            const parts = asofdate.split("/");
            let year = parseInt(parts[2], 10);
            const month = parseInt(parts[1], 10) - 1;
            const day = parseInt(parts[0], 10);
            if(year < 1000) {
                year += 2000;
            }
            asOfDateObject = new Date(year,
                month,
                day);
        }
        const asOfDateFormatted = asOfDateObject instanceof Date && !isNaN(asOfDateObject)
            ? asOfDateObject.toLocaleDateString('en-GB', {
                day : 'numeric',
                month : 'short',
                year : 'numeric'
            })
            : asofdate;
        const asOfDateText = asofdate ? asOfDatePlaceholder.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/{asofdate}/g, asOfDateFormatted) : "";

        var totalFunds = fundExplorer.allTickers[fundExplorer.currentdata.InvType.toLowerCase()].length;
        var currentFunds = fundExplorer.currentdata.FundSet.length;

        if (totalFunds === 0) {
            return;
        }

        const showingText = showingPlaceholder.replace("{currentFunds}", currentFunds).replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/{totalFunds}/g, totalFunds);
        $(".fund-explorer-table__showing").html(showingText + asOfDateText);
    },

    getFundTypeFromTicker: function (ticker) {
        var ticker = ticker.toUpperCase();
        for (var t in fundExplorer.allTickers) {
            var theTicker = fundExplorer.allTickers[t].find(function (e, i) {
                return e.id == ticker;
            });
            if (typeof theTicker != "undefined") return theTicker.fundType;
        }
        return false;
    }

}

/*
 * Common utilities used above.
 */
window.feutils = {
    spinner: {
        init: function () {
            $("#veSpinnerContainer").append('<div id="loading"><div id="loadingcontent"><p id="loadingspinner"></p></div></div>');
            $("#veLoginSpinnerContainer").append('<div id="loginloading"><div id="loadingcontent"><p id="loadingspinner"></p></div></div>');
            //$('#viewport-wide-spinner').hide();
            feutils.spinner.theSpinner = feutils.spinner.load();
        },
        load: function () {

            eventType = "blur";
            id = "loading";

            //If want to change the text below the spinning div.
            //if (progressText != undefined) { $("#loadingspinner").html(progressText); }
            $('#loading').fadeIn();
            var opts = {
                lines: 12, // The number of lines to draw
                length: 7, // The length of each line
                width: 4, // The line thickness
                radius: 10, // The radius of the inner circle
                color: '#000', // #rgb or #rrggbb
                speed: 1, // Rounds per second
                trail: 60, // Afterglow percentage
                shadow: false, // Whether to render a shadow
                hwaccel: false // Whether to use hardware acceleration
            };
            var target = document.getElementById('loading');
            var spinner = new Spinner(opts).spin(target);

            return spinner;
        },
        hide: function () { $('#viewport-wide-spinner').hide();},
        show: function () { $('#viewport-wide-spinner').show();}


    },

    rnCode: function (tag, innerHtml, id, classes, attributes) {
        if (!tag) { console.error("Tag not provided"); return false; }
        classes = classes ? "class='" + classes + "'" : "";
        id = id ? "id='" + id + "'" : "";
        attributes = attributes || "";
        innerHtml = innerHtml || "";

        return "<" + tag + " " + attributes + " " + id + " " + classes + ">" + innerHtml + "</" + tag + ">";
	},

	arrString: function(array) {
		if (typeof array != "object") {
            return "error";
		}

        return array.map(function(e) { return '"' + e + '"' }).join(",");
    },
    /**
     * Returns if all of these selectors are checked.
     * @param {String} checkboxSelectors
     */
    isAllChecked: function (checkboxSelectors) {
        return $(checkboxSelectors).length === $(checkboxSelectors + ":checked").length;
    },

    getSvg: function(x) {
        switch(x) {
            case "up":
            case "top":
                return '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="long-arrow-alt-up" class="svg-inline--fa fa-long-arrow-alt-up fa-w-10 fa-sm fund-explorer-table__chevron-up" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12"> <path fill="currentColor" d="M3 11.25a.5.5 0 00.5.5.5.5 0 00.5-.5V.75a.5.5 0 00-.5-.5.5.5 0 00-.5.5zM.3 3.47a.5.5 0 00.15.33.5.5 0 00.7 0L3.5 1.46 5.85 3.8a.5.5 0 00.7 0 .5.5 0 000-.7L3.85.4a.5.5 0 00-.7 0L.45 3.1a.5.5 0 00-.15.37z"> </path> </svg>';

            case "bottom":
            case "down":
                return '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="long-arrow-alt-down" class="svg-inline--fa fa-long-arrow-alt-down fa-w-10 fa-sm fund-explorer-table__chevron-up fund-explorer-table__chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12"> <path fill="currentColor" d="M3 11.25a.5.5 0 00.5.5.5.5 0 00.5-.5V.75a.5.5 0 00-.5-.5.5.5 0 00-.5.5zM.3 8.57a.5.5 0 00.15.33l2.7 2.7a.5.5 0 00.7 0l2.7-2.7a.5.5 0 000-.7.5.5 0 00-.7 0L3.5 10.54 1.15 8.2a.5.5 0 00-.7 0 .5.5 0 00-.15.37z"> </path> </svg>';

            case "sortIconDefault":
                return '<div class="table-thead-icon" > <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="exchange-v" class="svg-inline--fa fa-exchange-v fa-w-19 fa-sm icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 12">  <path fill="currentColor" d="M10.25 11.25a.5.5 0 00.5.5.5.5 0 00.5-.5V.75a.5.5 0 00-.5-.5.5.5 0 00-.5.5zm-2.7-7.78a.5.5 0 00.15.33.5.5 0 00.7 0l2.35-2.34L13.1 3.8a.5.5 0 00.7 0 .5.5 0 000-.7L11.1.4a.5.5 0 00-.7 0L7.7 3.1a.5.5 0 00-.15.37zm-4.8 7.78a.5.5 0 00.5.5.5.5 0 00.5-.5V.75a.5.5 0 00-.5-.5.5.5 0 00-.5.5zM.05 8.57a.5.5 0 00.15.33l2.7 2.7a.5.5 0 00.7 0l2.7-2.7a.5.5 0 000-.7.5.5 0 00-.7 0l-2.35 2.34L.9 8.2a.5.5 0 00-.7 0 .5.5 0 00-.15.37z"></path></svg></div >';

            case "sortIconCompound":
                return '<div class="table-thead-icon"><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="sliders-v" class="svg-inline--fa fa-sliders-v fa-w-16 fa-sm icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="currentColor" d="M12.92 3.03c-.93.14-1.63.94-1.66 1.88-.06.91.54 1.76 1.42 2 .86.27 1.8-.09 2.27-.86.5-.78.38-1.82-.29-2.46a1.98 1.98 0 00-1.74-.56zm.17.98c.3-.05.65.06.87.28.3.3.37.88.14 1.23a.5.5 0 000 .02c-.22.35-.73.54-1.13.42a.5.5 0 00-.01 0c-.4-.12-.74-.58-.71-1a.5.5 0 000-.02c.01-.42.4-.86.82-.92a.5.5 0 00.02 0zM7.67 9.03c-.93.14-1.63.94-1.66 1.88-.06.91.54 1.76 1.42 2 .86.27 1.8-.09 2.27-.86.5-.78.38-1.82-.29-2.46a1.98 1.98 0 00-1.74-.56zm.17.98c.3-.05.65.06.87.28.3.3.37.88.14 1.23a.5.5 0 000 .02c-.22.35-.73.54-1.13.42a.5.5 0 00-.01 0c-.4-.12-.74-.58-.71-1a.5.5 0 000-.02c.01-.42.4-.86.82-.92a.5.5 0 00.02 0zM2.42 3.03c-.93.14-1.63.94-1.66 1.88-.06.91.54 1.76 1.42 2 .86.27 1.8-.09 2.27-.86.5-.78.38-1.82-.29-2.46a1.98 1.98 0 00-1.74-.56zm.17.98c.3-.05.65.06.87.28.3.3.37.88.14 1.23a.5.5 0 000 .02c-.22.35-.73.54-1.13.42a.5.5 0 00-.01 0c-.4-.12-.74-.58-.71-1a.5.5 0 000-.02c.01-.42.4-.86.82-.92a.5.5 0 00.02 0zM13.25 6a.5.5 0 00-.5.5v8.25a.5.5 0 00.5.5.5.5 0 00.5-.5V6.5a.5.5 0 00-.5-.5zm0-5.25a.5.5 0 00-.5.5V3.5a.5.5 0 00.5.5.5.5 0 00.5-.5V1.25a.5.5 0 00-.5-.5zM8 12a.5.5 0 00-.5.5v2.25a.5.5 0 00.5.5.5.5 0 00.5-.5V12.5A.5.5 0 008 12zM8 .75a.5.5 0 00-.5.5V9.5a.5.5 0 00.5.5.5.5 0 00.5-.5V1.25a.5.5 0 00-.5-.5zM2.75 6a.5.5 0 00-.5.5v8.25a.5.5 0 00.5.5.5.5 0 00.5-.5V6.5a.5.5 0 00-.5-.5zm0-5.25a.5.5 0 00-.5.5V3.5a.5.5 0 00.5.5.5.5 0 00.5-.5V1.25a.5.5 0 00-.5-.5z"></path></svg></div>';

            case "searchButton":
                return '<div class="input-group-append"><button class="btn btn-white btn-small" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path></svg></button></div>';

            case "morningstar":
                return '<svg aria-hidden="true" focusable="false" data-prefix="fa" data-icon="star" class="svg-inline--fa fa-star fa-w-18 fa-sm mr-1" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"> <path fill="currentColor" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"> </path> </svg>';

            case "infoIcon":
                return '<svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Fund-Explorer" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Utility_Screener_Default" transform="translate(-353.000000, -570.000000)"><g id="More-Info-Icon" transform="translate(353.000000, 570.000000)"><circle id="Oval" stroke="#17468F" stroke-width="1.25" cx="7.5" cy="7.5" r="6.875"></circle><path d="M7.50549316,5.35949707 C8.27087402,5.35949707 8.65356445,5.04455566 8.65356445,4.41467285 C8.65356445,4.09973145 8.56201172,3.86169434 8.37890625,3.70056152 C8.19580078,3.53942871 7.90466309,3.4588623 7.50549316,3.4588623 C7.10632324,3.4588623 6.8170166,3.53759766 6.63757324,3.69506836 C6.45812988,3.85253906 6.3684082,4.09240723 6.3684082,4.41467285 C6.3684082,5.04455566 6.74743652,5.35949707 7.50549316,5.35949707 Z M8.57116699,11.9637451 L8.57116699,5.96374512 L6.42333984,5.96374512 L6.42333984,11.9637451 L8.57116699,11.9637451 Z" id="i" fill="#17468F" fill-rule="nonzero" transform="translate(7.510986, 7.711304) scale(-1, 1) translate(-7.510986, -7.711304) "></path></g></g></g></svg>';

            default:
                console.error('Not sure which icon to render!');
                return "";
        }
    },

    /**
     * Downloads the specified table as an Excel File.
     * @param {any} id
     */
    fnExcelReport: function(id)
    {
        tab = document.getElementById(id); // id of table
        $('#downloadZoneArea').remove();
        $('body').append('<iframe id="downloadZoneArea" style="display:none"></iframe>');

        var tab_text = tab.outerHTML;

        //tab_text = tab_text + "</table>";
        tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");//remove if u want links in your table
        tab_text = tab_text.replace(/<img[^>]*>/gi, ""); // remove if u want images in your table
        tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, ""); // reomves input params

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        var blob = new Blob([tab_text],
            {
                type: "application/vnd.ms-excel;charset=utf-8"
            });

        return saveAs(blob, "fund-data.xls");

    }
}

window.addEventListener("DOMContentLoaded", fundExplorer.init);